import {Label} from '@primer/react'

import labelStyles from '../../stack-section/EntryStatusLabel.module.css'
import {RebaseState} from '../../../../hooks/mutations/use-stack-rebase-mutation'

export function RebasingLabel({state}: {state?: RebaseState}) {
  if (state !== RebaseState.Rebasing) return null

  return (
    <Label variant="attention" className={labelStyles.solid}>
      Rebasing
    </Label>
  )
}
